<template>
  <div class="page">
    <div class="page-content">
      <v-row>
        <v-col cols="3" class="d-flex align-stretch" v-for="index in indexes" :key="index.index">
          <v-card class="index-card" outlined dark>
            <div class="card-header">
              <div class="index-title">{{ index.index }}</div>
              <v-menu bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon small rounded v-on="on">
                    <v-icon size="15">fas fa-ellipsis-v</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item @click="onOpenClear(index.index)">
                    <v-list-item-title>Executar limpeza</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <v-switch
              v-model="index.active"
              color="success"
              label="Salvar logs"
              dark
              @change="updateDebounced(index.index)"
            ></v-switch>
            <v-select
              :items="range"
              v-model="index.time"
              outlined
              dense
              label="Período"
              dark
              @change="updateDebounced(index.index)"
            ></v-select>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <v-dialog v-model="clear.open" dark max-width="500">
      <v-card dark>
        <v-card-title>
          <span class="headline">Apagar logs de {{clear.index}}</span>
        </v-card-title>
        <br />
        <v-card-subtitle v-if="!clear.confirm">
          Selecione até que data deseja deletar
        </v-card-subtitle>
        <v-card-subtitle v-if="clear.confirm">
          Confirma exclusão de logs inferiores a {{ clear.dateFormated }}
        </v-card-subtitle>
        <v-card-text v-if="!clear.confirm">
          <v-date-picker
            dark
            v-model="clear.date"
            light
            no-title
            full-width
          ></v-date-picker>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="clear.open = false"
            >Fechar</v-btn
          >
          <v-btn color="blue darken-1" text @click="onClear">Executar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar.open"
      :color="snackbar.color"
      left
      :timeout="1000"
    >
      {{ snackbar.message }}
    </v-snackbar>
  </div>
</template>

<script>
import { LogControl } from '../service/Api'
import * as _ from 'lodash'
import moment from 'moment'
export default {
  name: 'Logaudit',
  data: () => ({
    switch2: false,
    range: [
      {
        text: '1 semana',
        value: 'one_week',
      },
      {
        text: '2 semanas',
        value: 'two_weeks',
      },
      {
        text: '3 semanas',
        value: 'three_weeks',
      },
      {
        text: '1 mês',
        value: 'one_month',
      },
      {
        text: '2 meses',
        value: 'two_months',
      },
    ],
    model: 'one_month',
    indexes: [],
    updateDebounced: null,
    clear: {
      open: false,
      index: '',
      date: '',
      dateFormated: '',
    },
    snackbar: {
      open: false,
      message: '',
      color: 'info',
    },
  }),
  mounted() {
    LogControl.indexes()
      .then(data => {
        this.indexes = _.get(data, 'data')
      })
      .catch(err => {
        this.snackbar = {
          open: true,
          message: _.get(
            err,
            'response.data.message',
            'Falha ao buscar configuções de logs'
          ),
          color: 'error',
        }
      })
    this.updateDebounced = _.debounce(index => this.updateIndex(index), 500)
  },
  methods: {
    updateIndex(index) {
      const config = _.find(this.indexes, { index })
      if (config) {
        LogControl.update(index, {
          ...config,
        })
          .then(() => {
            this.snackbar = {
              open: true,
              message: 'Configurações de log atualizada',
              color: 'success',
            }
          })
          .catch(err => {
            this.snackbar = {
              open: true,
              message: _.get(
                err,
                'response.data.message',
                'Falha ao atualizar configurações de log'
              ),
              color: 'error',
            }
          })
      }
    },
    onOpenClear(index) {
      this.clear = {
        open: true,
        index,
        date: '',
      }
    },
    onClear() {
      if (!this.clear.confirm) {
        this.clear = {
          ...this.clear,
          dateFormated: moment(this.clear.date).format('DD/MM/YYYY'),
          confirm: true,
        }
      } else {
        const lessThen = moment(this.clear.date).toISOString()
        LogControl.clearByDate(this.clear.index, lessThen)
          .then(() => {
            this.snackbar = {
              open: true,
              message: 'Limpeza efetuada com sucesso',
              color: 'success',
            }
          })
          .catch(err => {
            this.snackbar = {
              open: true,
              message: _.get(
                err,
                'response.data.message',
                'Falha ao executar limpeza'
              ),
              color: 'error',
            }
          })
          this.clear = {
            open: false,
            index: '',
            date: '',
            dateFormated: ''
          }
      }
    },
  },
}
</script>

<style lang="scss">
.index-card {
  padding: 10px;
}
.card-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .index-title {
    font-size: 14px;
    padding: 5px;
    text-align: left;
  }
}
</style>
